import { allSparkDomains, Hex, NormalizedNumber, Percentage, SparkDomain } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'
import { Address, isAddress, isHex, Hex as ViemHex } from 'viem'
import * as z from 'zod'

import { SUPPORTED_CHAIN_IDS } from '@/config/chain/constants'
import { useStore } from '@/domain/state'

// number schemas
export const numberLikeSchema = z.union([
  z.string(),
  z.number(),
  z.custom<BigNumber>((val) => BigNumber.isBigNumber(val), {
    message: 'Must be a valid BigNumber',
  }),
  z.bigint(),
])
export const percentageSchema = numberLikeSchema.transform((a) => Percentage(a))
export const percentageAboveOneSchema = numberLikeSchema.transform((a) => Percentage(a, { allowMoreThan1: true }))
export const normalizedNumberSchema = numberLikeSchema.transform((a) => NormalizedNumber(a))

// address schemas
export const viemAddressSchema = z.custom<Address>((address) => isAddress(address as string))
export const hexSchema = z.custom<ViemHex>((hex) => isHex(hex)).transform((hex) => Hex(hex))

// misc schemas
export const supportedChainIdSchema = z.coerce.number().refine(
  (chainId) => {
    if (SUPPORTED_CHAIN_IDS.includes(chainId)) return true
    const sandboxForkChainId = useStore.getState().sandbox.network?.forkChainId
    return sandboxForkChainId !== undefined && chainId === sandboxForkChainId
  },
  { message: 'Chain id is not supported' },
)

export const sparkDomainSchema = z
  .string()
  .refine((domain): domain is SparkDomain => allSparkDomains.includes(domain), { message: 'Invalid Spark domain' })
